<template>
    <div v-if="isRoot">
        <el-dropdown-item @click.native="handlePauseClick" :disabled="projectPause">
            {{ pauseShow.label }}
        </el-dropdown-item>
        <!-- <el-dropdown-item @click.native="addCancelPause" :disabled="cancelPause_show || !userDisable || !isExecuter"
            v-if="!cancelPause_show || !userDisable">
            {{ $t("message.button.cancelPause") }}
        </el-dropdown-item> -->
        <el-dropdown-item @click.native="cancelProject" :disabled="projectPause">
            {{ $t("message.button.closeProject") }}
        </el-dropdown-item>

        <!-- <el-dropdown-item @click.native="addPause" :disabled="pause_show || !userDisable || !isExecuter"
            v-if="!pause_show || !userDisable">
            {{ $t("message.button.pause") }}
        </el-dropdown-item>
        <el-dropdown-item @click.native="addCancelPause" :disabled="cancelPause_show || !userDisable || !isExecuter"
            v-if="!cancelPause_show || !userDisable">
            {{ $t("message.button.cancelPause") }}
        </el-dropdown-item>
         <el-dropdown-item @click.native="addCancel" :disabled="cancelPause_show || !userDisable || !isExecuter"
            v-if="!cancelPause_show || !userDisable">
            {{ $t("message.button.closeProject") }}
        </el-dropdown-item> -->
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            pauseShow: {
                label: "",
                id: 0,
            },
            list: [
                this.$t("message.button.pause"),
                this.$t("message.button.cancelPause"),
            ],
        };
    },
    computed: {
        ...mapGetters({
            pauseStatus: "projectWorkflow/getProjectPauseStatus",
            projectStatus: "projectWorkflow/getProjectInfo",
            projectEcrInfo: 'projectWorkflow/getCreateEcrInfo'

        }),
        projectPause() {
            return !this.projectEcrInfo.pauseOrNotOperation
        },

        isRoot() {
            console.log(this.projectStatus);

            const { isRoot = 0 } = this.projectStatus.specialProjectVo;
            return !!isRoot;
        },
    },
    watch: {
        pauseStatus(val) {
            this.setPause(val);
        },
    },
    methods: {
        handlePauseClick() {
            const id = 1 - this.pauseShow.id;
            this.changeProjectSpecialStatus(id);
        },
        changeProjectSpecialStatus(statusId) {
            var stateVal = {
                projectId: this.$store.state.objectId.id,
                specialStatus: statusId,
            };
            axios
                .post("/ppm/project/changeProjectSpecialStatus", stateVal)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.object.message,
                            type: "success",
                        });
                        // this.pauseShow = { id: statusId, label: this.list[statusId] };
                        this.$set(this.pauseShow, "label", this.list[statusId]);

                        const { id, classId, subClassId } = this.$route.query;
                        this.$store.dispatch("projectWorkflow/getWorkFlowStatus", {
                            id,
                            classId,
                            subClassId,
                        });
                    }
                });
        },
        cancelProject() {
            const id = 2;
            this.changeProjectSpecialStatus(id);
        },
        setPause(data) {
            const { specialState: id } = data;
            this.pauseShow = {
                id,
                label: this.list[id],
            };
        },
    },
    mounted() {
        this.setPause(this.pauseStatus);
        console.log(this.projectEcrInfo);

    },
};
</script>

<style></style>